import { render, staticRenderFns } from "./Parlay.vue?vue&type=template&id=0ca6d357&scoped=true&"
import script from "./Parlay.vue?vue&type=script&lang=js&"
export * from "./Parlay.vue?vue&type=script&lang=js&"
import style0 from "./Parlay.vue?vue&type=style&index=0&id=0ca6d357&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca6d357",
  null
  
)

export default component.exports